export const pokerHistoryLinks = {
  da: "/app/pokerhistorik/",
  deu: "/app/pokerverlauf/",
  en: "/app/poker-history/",
  es: "/app/historial-de-poker/",
  fi: "/app/pokeririhistoria/",
  fr: "/app/historique-de-poker/",
  it: "/app/cronologia-poker/",
  pt: "/app/historico-de-poker/",
  ro: "/app/istoric-poker/",
  ru: "/app/poker-history/",
  sv: "/app/pokerhistorik/",
  ua: "/app/poker-history/",
  br: "/app/historico-de-poker/"
};
